import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=70d5e067&scoped=true&"
import script from "./CouponList.vue?vue&type=script&lang=js&"
export * from "./CouponList.vue?vue&type=script&lang=js&"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=70d5e067&lang=scss&scoped=true&"
import style1 from "./CouponList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CouponList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5e067",
  null
  
)

export default component.exports